module.exports = __webpack_public_path__ + "img/2-1.ed9f14cc.png";